<template>
  <div
    v-if="searchable"
    class="flex"
    :class="[marginBottom]"
  >
    <input 
      class="w-full shadow p-2" 
      type="text" 
      placeholder="Suchen..." 
      :value="value"
      :style="{backgroundColor:searchInputColor}"
      :class="[cssRadius]"
      @input="emitValue"  
    >
  </div>
</template>

<script>
export default {
  props: {
    searchable: {
      type: [Boolean, Number],
      default: false
    },
    value: {
      type: String,
      default: 'rounded-lg'
    },
    cssRadius: {
      type: String,
      default: '',
    },
    searchInputColor: {
      type: String,
      default: ''
    },
    marginBottom: {
      type: String,
      default: 'mb-5'
    }
  },
  methods: {
    emitValue(value) {
      this.$emit('input', value.target.value)
    }
  }
}
</script>